// @flow

const localDateTimeIso8601 = "YYYY-MM-DD[T]HH:mm";

export default localDateTimeIso8601;
